import { ROUTES } from './constants';

const BETA_ONLY_PREFIXES = [
  ROUTES.V2.SALES_ORDERS,
  ROUTES.V2.SALES,
  ROUTES.V2.PURCHASE_ORDERS,
  ROUTES.V2.PURCHASES,
  ROUTES.PRODUCTS.ROOT,
  ROUTES.SALES.ROOT,
  ROUTES.EXPENSES.ROOT,
  ROUTES.STORAGE.ROOT,
  ROUTES.SCHEDULES.ROOT,
  ROUTES.CHAT,
  ROUTES.API_KEYS,
  ROUTES.MEMBERSHIP.ROOT,
  ROUTES.MEMBERSHIP.WEBSITE_BUILDER,
  '/website-builder/pages',
  '/website-builder/page',
  ROUTES.CHURCH.REPORTS.ROOT,
  ROUTES.PERMISSION.ROOT,
  ROUTES.ROLE.ROOT,
  ROUTES.COMPANY.USERS,
] as const;

export function isBetaOnlyPath(path: string): boolean {
  return BETA_ONLY_PREFIXES.some((prefix) => path.startsWith(prefix));
}
